import styled, { css, color, device, themeGet } from '@styled'
import { Col } from '@ui/wrapper'

export const JuryContainerWrapper = styled.div`
  overflow-x: clip;
`

export const SectionWrapper = styled.section`
  padding-block-start: 20px;
  padding-block-end: 60px;
  background-color: #f2f8fc !important;
  ${color}
`

export const CategorySectionWrapper = styled.section`
  padding-block-start: 30px;
  padding-block-end: 30px;
  background-image: linear-gradient(
    90deg,
    rgba(122, 165, 184, 0.5) 0%,
    rgba(255, 255, 255, 0.5) 100%
  );
  overflow: hidden;
  position: relative;
`

export const CategoryBGCircle = styled.div`
  position: absolute;
  border-radius: 50%;
  opacity: 0.1;
  ${(props) =>
    props.layout === 1
      ? css`
          left: 15%;
          top: 50%;
          width: 60vw;
          height: 60vw;
          border: 10vw solid rgb(122, 165, 184);
          min-width: 500px;
          min-height: 500px;
          transform: translate(-50%, -50%);
        `
      : css`
          right: 15%;
          bottom: 0%;
          width: 40vw;
          height: 40vw;
          border: 5vw solid rgb(122, 165, 184);
          min-width: 350px;
          min-height: 350px;
          transform: translate(50%, 50%);
        `}
`

export const CategoryWrapper = styled(Col)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  margin-bottom: 20px;
  min-height: 200px;

  h5 {
    color: ${themeGet('colors.primary')};
  }
`

export const CategoryIconWrapper = styled.div`
  position: absolute;
  top: 15%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 40px;
  margin-bottom: 10px;
  color: ${themeGet('colors.secondary')};
`

export const UnderlinedLink = styled.a`
  :hover {
    cursor: pointer;
    text-decoration: underline !important;
  }
  margin-inline-end: 20px;
`

export const StyledText = styled.div`
  margin-block-start: 15px;
  margin-block-end: 25px;
  font-size: 18px;
  margin-inline-start: 10px;
  margin-inline-end: 10px;
  ${device.small} {
    margin-inline-start: 34px;
    margin-inline-end: 34px;
  }
  b {
    font-weight: 700;
  }
  ul {
    list-style: disc;
    margin-left: 20px;
  }
`

export const SwiperWrapper = styled.div``

export const SlideItemWrapper = styled.div`
  width: ${(props) => props.width}px;
  height: 300px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  cursor: pointer;
  opacity: 1;
  &:hover {
    opacity: 0.5;
  }
`

export const SlideItemWrapperFull = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;

  img {
    max-width: 100%;
    max-height: 100vh;
    width: auto;
    height: auto;
    object-fit: contain;
  }
`

export const ButtonWrapper = styled.a`
  position: absolute;
  z-index: 1000;
  display: flex;
  color: grey;
  justify-content: center;
  align-items: center;
  background: white;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  box-shadow:
    0 2px 5px 0 rgba(0, 0, 0, 0.26),
    0 2px 10px 0 rgba(0, 0, 0, 0.16);
  font-size: 20px;
  transition:
    box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1),
    background 150ms cubic-bezier(0.4, 0, 0.2, 1),
    color 150ms cubic-bezier(0.4, 0, 0.2, 1);
  ${(props) => {
    switch (props.type) {
      case 'left':
        return `
                    left: 50%;
                    margin-top: 5px;
                    transform: translateX(-150%);
                    margin-left: 1%;
                    ${device.small} {
                      left: 0;
                      top: 50%;
                      transform: translateY(-50%) translateX(-30%);
                      margin-left: 1%;
                    }
                `
      case 'right':
        return `
                    right: 50%;
                    margin-top: 5px;
                    transform: translateX(150%);
                    margin-right: 1%;
                    ${device.small} {
                      right: 0;
                      top: 50%;
                      transform: translateY(-50%) translateX(30%);
                      margin-right: 1%;
                    }
                `
      case 'top-right':
        return `
                    right: 0%;
                    margin-top: 5px;
                    transform: translateX(20%) translateY(10%);
                    margin-right: 20px;
                    right: 0;
                    top: 0;

                `
      case 'top-right-2':
        return `
                    right: 0;
                    margin-top: 5px;
                    transform: translateX(-250%);
                    ${device.small} {
                      right: 0;
                      top: 0;
                      transform: translateY(200%) translateX(30%);
                      margin-right: 1%;
                    }
                `
    }
  }};
  ${device.small} {
    width: 35px;
    height: 35px;
    font-size: 22px;
  }
  ${device.medium} {
    width: 40px;
    height: 40px;
    font-size: 23px;
  }
  ${device.large} {
    width: 40px;
    height: 40px;
    font-size: 23px;
  }
  &:hover {
    cursor: pointer;
    color: rgb(181 90 48 / 100%);
    box-shadow:
      0 2px 10px 0 rgba(181, 90, 48, 0.26),
      0 2px 15px 0 rgba(181, 90, 48, 0.16);
  }
`
